const differenceCards = [
  {
    icon: "ri-microscope-line",
    text: "Penetrates micro-cracks invisible to the naked eye",
  },
  {
    icon: "ri-arrow-left-right-line",
    text: "Travels opposite to water — pushing it out permanently",
  },
  {
    icon: "ri-shield-flash-line",
    text: "Cures like rubber — flexible and permanent under movement",
  },
  {
    icon: "ri-water-flash-line",
    text: "Works even under active hydrostatic pressure",
  },
];

export default function DifferenceSection() {
  return (
    <section id="difference" className="bg-[#1a3a5c] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Large bold statement */}
        <div className="text-center mb-14">
          <p className="text-[#8ab4cc] font-bold uppercase tracking-widest text-sm mb-4">The CLWizard Difference</p>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight max-w-4xl mx-auto">
            We Don&apos;t Touch the Surface.{" "}
            <span className="text-[#0a0e1a]">We Go Inside the Concrete.</span>
          </h2>
        </div>

        {/* Body text */}
        <div className="max-w-3xl mx-auto text-center mb-14">
          <p className="text-blue-100 text-lg leading-relaxed">
            CLWizard&apos;s{" "}
            <strong className="text-white">Elastic Polyvinyl Liquid DWG Nano-Polymer ECO V®</strong> has the same
            viscosity as water. It travels through the exact same pathways water uses — and seals them permanently from
            within. No jackhammers. No demolished floors. No displaced residents.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {differenceCards.map((card) => (
            <div
              key={card.text}
              className="bg-white/10 border border-white/20 rounded-lg p-6 flex flex-col items-start gap-4 hover:bg-white/20 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20">
                <i className={`${card.icon} text-white text-2xl`}></i>
              </div>
              <p className="text-white font-semibold text-sm leading-relaxed">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
